import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface CommonState {
  data: {
    loading: boolean;
  };
}

const initialCommonState: CommonState = {
    data:{
        loading:false,
    },
}


const commonSlice = createSlice({
  name: "common",
  initialState: initialCommonState,
  reducers: {
    setLoading: (state, action: PayloadAction<boolean>) => {
        state.data.loading = action.payload;
    },
  }
})

export const {
    setLoading,
} = commonSlice.actions;

export { commonSlice };
